/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2023, Zumper
 */
import { toCityUrl } from '@zcode/nr-utils'
import { NEW_YORK_BOROUGHS_URLS } from '@zcode/nr/es/shared/components/Autocomplete/constants'
import type { MaybeEmptyProperty } from '@zcode/state-type'

import {
  getBaseUrlFromPropertyType,
  getPropertyTypeLabel,
} from '../../../modules/currentSearch/modules/location/selectors/helpers'
import { toHoodUrl } from '../../../utils/urls/toHoodUrl'

export const getHoodAndCityLinks = (
  entity: MaybeEmptyProperty,
  omitPropertyTypeLabel?: boolean
) => {
  const links = []
  const { city, cityState, neighborhood, neighborhoodName, propertyType, state } = entity
  const isNYCBorough =
    cityState && !!(Object.values(NEW_YORK_BOROUGHS_URLS) as string[])?.includes(cityState)
  const hood = neighborhoodName ?? neighborhood?.name
  const propertyTypeLabel = getPropertyTypeLabel(propertyType, false)
  const basePath = getBaseUrlFromPropertyType({ propertyType })
  const hoodUrl =
    hood &&
    toHoodUrl({
      city,
      state,
      cityState,
      hood,
      basePath,
    })
  const cityUrl = toCityUrl({ city, state, cityState, basePath })

  if (isNYCBorough) {
    const nyUrl = toCityUrl({ cityState: 'new-york-ny', basePath })
    if (nyUrl) {
      links.push({
        label: `New York ${omitPropertyTypeLabel ? '' : propertyTypeLabel}`,
        url: nyUrl,
      })
    }
  }
  if (city && cityUrl) {
    links.push({ label: `${city} ${omitPropertyTypeLabel ? '' : propertyTypeLabel}`, url: cityUrl })
  }
  if (hood && hoodUrl) {
    links.push({ label: `${hood} ${omitPropertyTypeLabel ? '' : propertyTypeLabel}`, url: hoodUrl })
  }
  return links
}
